/* eslint-disable no-undef */
// 导入oading
import "css-loading";
import "./burySalog";
//import { componentControl as control } from "../eventManagement/componentControl";

var cc = window.cc || {};
cc.activityCode = "cultivate";
cc.loginStatus = false;
// 区分环境，不同的环境使用不同的地址
cc.config = (function() {
  let config = null;
  switch ($.base.getEnvName()) {
    case "PRE":
      config = {
        idsauthServerUrl: "https://passportpre.cnsuning.com",
        idsauthUrl: "https://aqpre.cnsuning.com/asc/auth",
        cmsApiDomain: "//libpre.cnsuning.com",
        actDomain: "//actpre.cnsuning.com",
        maxDomain: "//maxpspre.cnsuning.com",
        base: "https://mypre.cnsuning.com/",
        resDomain: "//presslres.suning.com",
        dtDomain: "//dtpre.cnsuning.com",
        fpDomain: "//fppre.cnsuning.com",
        cookieDomain: "cnsuning.com",
        imgPath:
          "//presslres.suning.com/project/cmsWeb/suning/redpacket/2017818/starry/page1Image",
        imgDomain: "//cprexg.m.cnsuning.com",
        sale: "//salepre.cnsuning.com/pre_first/",
        turnLion: "//salepre.cnsuning.com/pre_first/gpTurnLion/",
        msuning: "//mpre.cnsuning.com",
        icps: "//icpspre.cnsuning.com",
        dfpDomain: "//dfppre.cnsuning.com",
        mmdsDomain: "//mmdssit.cnsuning.com",
        checkLogin: "https://regpre.cnsuning.com",

        SWELL_mpayDomain: "https://mpaypre.cnsuning.com/",
        sn_config_cmsLibDomain: "//libpre.cnsuning.com",
        SWELL_idsauthServerUrl: "https://passportpre.cnsuning.com",
        SWELL_base: "https://mypre.cnsuning.com/",
        SWELL_my: "https://mypre.cnsuning.com",
        SWELL_actDomain: "//actpre.cnsuning.com",
        SWELL_cmsDomain: "//c.m.suning.com",
        SWELL_cmsLibDomain: "//libpre.cnsuning.com",
        SWELL_saleDomain: "//salepre.cnsuning.com",
        hbRecords: "//hbh5prexg.cnsuning.com/fmresh/hbRecords/index.htm",
        lingqianbao: "//mhqpre.cnsuning.com",
        SWELL_kehuduan: "//cpre.m.cnsuning.com",
        goUp: "https://aqpre.cnsuning.com",
        GAME_API: "//gameapipre.cnsuning.com"
      };
      break;
    case "XGPRE":
      // config = {
      //   SWELL_saleDomain: "//saleprexg.cnsuning.com",
      //   SWELL_mpayDomain: "//mpayprexg.cnsuning.com/",
      //   SWELL_pinPicDomain: "//uimgpre.cnsuning.com",
      //   SWELL_quanDomain: "//quanprexg.cnsuning.com",
      //   SWELL_kehuduan: "//cprexg.m.cnsuning.com",
      //   SWELL_jrDomain: "//hbh5prexg.cnsuning.com",
      //   SWELL_tXAddress:
      //     "//passportpre.cnsuning.com/ids/trustLogin?sysCode=epp&agentType=wap&targetUrl=https%3a%2f%2fhqpre.cnsuning.com%2fbof%2fapp%2fredpackets%2fwithdraw.htm",
      //   SWELL_idsauthServerUrl: "//passportprexg.cnsuning.com",
      //   SWELL_actDomain: "//actprexg.cnsuning.com",
      //   SWELL_cmsLibDomain: "//libprexg.cnsuning.com",
      //   SWELL_cmsDomain: "//cprexg.m.cnsuning.com",
      //   idsauthServerUrl: "https://passportprexg.cnsuning.com",
      //   idsauthUrl: "https://aqprexg.cnsuning.com/asc/auth",
      //   cmsApiDomain: "//libprexg.cnsuning.com",
      //   actDomain: "//actprexg.cnsuning.com",
      //   maxDomain: "//maxpsprexg.cnsuning.com",
      //   base: "https://myprexg.cnsuning.com/",
      //   resDomain: "//presslresxg.suning.com",
      //   dtDomain: "//dtxgpre.cnsuning.com",
      //   mmdsDomain: "//mmdspre.cnsuning.com",
      //   fpDomain: "//fpxgpre.cnsuning.com",
      //   cookieDomain: "cnsuning.com",
      //   imgPath:
      //     "//presslresxg.suning.com/project/cmsWeb/suning/redpacket/2017818/starry/page1Image",
      //   imgDomain: location.host.indexOf("cuxiao")
      //     ? "//libprexg.cnsuning.com"
      //     : "//cuxiaoprexg.m.cnsuning.com",
      //   sale: "//saleprexg.cnsuning.com/pre_first/",
      //   turnLion: "//saleprexg.cnsuning.com/pre_first/gpTurnLion/",
      //   msuning: "//mxgpre.cnsuning.com",
      //   icps: "//icpsxgpre.cnsuning.com",
      //   dfpDomain: "//dfpxgpre.cnsuning.com",
      //   hbRecords: "//hbh5prexg.cnsuning.com/fmresh/hbRecords/index.htm",
      //   lingqianbao: "//mhqxgpre.cnsuning.com",
      //   checkLogin: "https://regprexg.cnsuning.com",
      //   goUp: "https://aqprexg.cnsuning.com",
      //   tuijian: "https://tuijian.suning.com", // 'https://tuijianxgpre.cnsuning.com'
      //   dsrec: "https://dsrec.suning.com",
      //   shiwuAddr: `//luckyprexg.cnsuning.com/award/my/award_1.html`, // 中奖实物券地址
      //   myCoupon: `http://res.mprexg.cnsuning.com/project/quan/dist/myCoupon.html#/`, // 我的优惠券
      //   yunZan: `https://sign.suning.com/sign-web/m/sign/welcome.do`, //跳转到云钻
      //   GAME_API: "//gameapiprexg.cnsuning.com"
      // };
      config = {
        idsauthServerUrl: "https://passportpre.cnsuning.com",
        idsauthUrl: "https://aqpre.cnsuning.com/asc/auth",
        cmsApiDomain: "//libprexg.cnsuning.com",
        actDomain: "//actpre.cnsuning.com",
        maxDomain: "//maxpspre.cnsuning.com",
        base: "https://mypre.cnsuning.com/",
        resDomain: "//presslres.suning.com",
        dtDomain: "//dtpre.cnsuning.com",
        fpDomain: "//fppre.cnsuning.com",
        cookieDomain: "cnsuning.com",
        imgPath:
          "//presslres.suning.com/project/cmsWeb/suning/redpacket/2017818/starry/page1Image",
        imgDomain: "//cprexg.m.cnsuning.com",
        sale: "//salepre.cnsuning.com/pre_first/",
        turnLion: "//salepre.cnsuning.com/pre_first/gpTurnLion/",
        msuning: "//mpre.cnsuning.com",
        icps: "//icpspre.cnsuning.com",
        dfpDomain: "//dfppre.cnsuning.com",
        mmdsDomain: "//mmdssit.cnsuning.com",
        checkLogin: "https://regpre.cnsuning.com",

        SWELL_mpayDomain: "https://mpaypre.cnsuning.com/",
        sn_config_cmsLibDomain: "//libpre.cnsuning.com",
        SWELL_idsauthServerUrl: "https://passportpre.cnsuning.com",
        SWELL_base: "https://mypre.cnsuning.com/",
        SWELL_my: "https://mypre.cnsuning.com",
        SWELL_actDomain: "//actpre.cnsuning.com",
        SWELL_cmsDomain: "//c.m.suning.com",
        SWELL_cmsLibDomain: "//libpre.cnsuning.com",
        SWELL_saleDomain: "//salepre.cnsuning.com",
        hbRecords: "//hbh5prexg.cnsuning.com/fmresh/hbRecords/index.htm",
        lingqianbao: "//mhqpre.cnsuning.com",
        SWELL_kehuduan: "//cpre.m.cnsuning.com",
        goUp: "https://aqpre.cnsuning.com",
        shiwuAddr: `//luckyprexg.cnsuning.com/award/my/award_1.html`, // 中奖实物券地址
        myCoupon: `http://res.mprexg.cnsuning.com/project/quan/dist/myCoupon.html#/`, // 我的优惠券
        yunZan: `https://sign.suning.com/sign-web/m/sign/welcome.do`, //跳转到云钻
        GAME_API: "//gameapipre.cnsuning.com"
      };
      break;
    case "SIT":
      config = {
        idsauthServerUrl: "https://passportsit.cnsuning.com",
        idsauthUrl: "https://aqsit.cnsuning.com/asc/auth",
        cmsApiDomain: "//libsit.cnsuning.com",
        actDomain: "//actsit.cnsuning.com",
        maxDomain: "//maxpssit.cnsuning.com",
        base: "https://mysit.cnsuning.com/",
        resDomain: "//sitres.suning.cn/",
        dtDomain: "//dtpre.cnsuning.com",
        fpDomain: "//fppre.cnsuning.com",
        cookieDomain: "cnsuning.com",
        imgPath:
          "//sitres.suning.cn/project/cmsWeb/suning/redpacket/2017818/starry/page1Image",
        imgDomain: "//uimgsit.cnsuning.com",
        sale: "//salesit.cnsuning.com/pre_first/",
        turnLion: "//salesit.cnsuning.com/pre_first/gpTurnLion/",
        msuning: "//msit.cnsuning.com",
        icps: "//icpssit.cnsuning.com",
        dfpDomain: "//dfpsit.cnsuning.com",
        mmdsDomain: "//mmdssit.cnsuning.com",
        checkLogin: "https://regsit.cnsuning.com",

        sn_config_cmsLibDomain: "//libsit.cnsuning.com",
        SWELL_idsauthServerUrl: "https://passportsit.cnsuning.com",
        SWELL_base: "https://mysit.cnsuning.com/",
        SWELL_my: "https://mysit.cnsuning.com",
        SWELL_actDomain: "//actsit.cnsuning.com",
        SWELL_cmsDomain: "//c.m.suning.com",
        SWELL_cmsLibDomain: "//libsit.cnsuning.com",
        SWELL_saleDomain: "//salesit.cnsuning.com",
        hbRecords: "//hbh5prexg.cnsuning.com/fmresh/hbRecords/index.htm",
        lingqianbao: "//mhqsit.cnsuning.com",
        SWELL_kehuduan: "//cpsit.m.cnsuning.com",
        GAME_API: "//gameapiprexg.cnsuning.com"
      };
      break;
    case "PRD":
      config = {
        idsauthServerUrl: "https://passport.suning.com",
        idsauthUrl: "https://aq.suning.com/asc/auth",
        cmsApiDomain: "//lib.suning.com",
        actDomain: "//act.suning.com",
        maxDomain: "//maxps.suning.com",
        base: "https://loginst.suning.com/",
        resDomain: "//res.suning.cn",
        dtDomain: "//dt.suning.com",
        fpDomain: "//fp.suning.com",
        cookieDomain: "suning.com",
        imgPath:
          "//res.suning.cn/project/cmsWeb/suning/redpacket/2017818/starry/page1Image",
        imgDomain: location.host.indexOf("cuxiao")
          ? "//c.m.suning.com"
          : "//cuxiao.m.suning.com",
        sale: "//sale.suning.com/all/",
        turnLion: "//sale.suning.com/all/gpTurnLion/",
        msuning: "//m.suning.com",
        icps: "//icps.suning.com",
        dfpDomain: "//dfp.suning.com",
        mmdsDomain: "//mmds.suning.com",
        checkLogin: "https://reg.suning.com",

        sn_config_cmsLibDomain: "//lib.suning.com",
        SWELL_idsauthServerUrl: "https://passport.suning.com",
        SWELL_base: "https://loginst.suning.com/",
        SWELL_kehuduan: "//m.suning.com/",
        SWELL_my: "https://my.suning.com",
        SWELL_actDomain: "//act.suning.com",
        SWELL_cmsDomain: "//c.m.suning.com",
        SWELL_cmsLibDomain: "//lib.suning.com",
        SWELL_saleDomain: "//sale.suning.com",
        SWELL_mpayDomain: "https://mpay.suning.com/",
        hbRecords: "//hbh5prexg.cnsuning.com/fmresh/hbRecords/index.htm",
        lingqianbao: "//mhq.suning.com",
        goUp: "https://aq.suning.com",
        tuijian: "https://tuijian.suning.com",
        dsrec: "https://dsrec.suning.com",
        shiwuAddr: `//lucky.suning.com/award/my/award_1.html`, // 中奖实物地址
        myCoupon: `//res.m.suning.com/project/quan/dist/myCoupon.html#/`, // 我的优惠券
        yunZan: `https://sign.suning.com/sign-web/m/sign/welcome.do`, //跳转到云钻
        GAME_API: "//gameapi.suning.com"
      };
      break;
    case "DEV":
      config = {
        idsauthServerUrl: "https://passportprexg.cnsuning.com",
        idsauthUrl: "https://aqprexg.cnsuning.com/asc/auth",
        cmsApiDomain: "//libprexg.cnsuning.com",
        actDomain: "//actprexg.cnsuning.com",
        maxDomain: "//maxpsprexg.cnsuning.com",
        base: "https://myprexg.cnsuning.com/",
        resDomain: "//presslresxg.suning.com",
        dtDomain: "//dtxgpre.cnsuning.com",
        fpDomain: "//fpxgpre.cnsuning.com",
        cookieDomain: "cnsuning.com",
        imgPath:
          "//presslresxg.suning.com/project/cmsWeb/suning/redpacket/2017818/starry/page1Image",
        imgDomain: "//cprexg.m.cnsuning.com",
        sale: "//saleprexg.cnsuning.com/pre_first/",
        turnLion: "//saleprexg.cnsuning.com/pre_first/gpTurnLion/",
        msuning: "//mxgpre.cnsuning.com",
        icps: "//icpsxgpre.cnsuning.com",
        dfpDomain: "//dfpxgpre.cnsuning.com",
        hbRecords: "//hbh5prexg.cnsuning.com/fmresh/hbRecords/index.htm",
        lingqianbao: "//mhqxgpre.cnsuning.com",
        SWELL_kehuduan: "//cprexg.m.cnsuning.com",
        checkLogin: "https://regprexg.cnsuning.com",
        GAME_API: "//gameapiprexg.cnsuning.com"
      };
  }
  window.passport_config = {
    base: config.base,
    loginTheme: "wap_new"
  };
  return config;
})();

// 接口请求地址
cc.request_url = {
  // cms地址
  cmsUrl: cc.config.cmsApiDomain + "/api/jsonp/{actcode}.jsonp",
  // 获取分享图
  getMergeUrl:
    cc.config.actDomain + "/act-wap-web/wechatimage/imagemerge/getMergeUrl.do",
  // 活动状态查询
  checkGame: cc.config.maxDomain + "/goldegg/activityInfo.html",
  // 任务状态查询
  checkTask: cc.config.maxDomain + "/goldegg/family/queryTaskInfo.do",
  // 抽奖
  getRewards: cc.config.maxDomain + "/goldegg/family/getRewards.do",
  // 兑换
  exchangeGoods:
    cc.config.actDomain + "/act-wap-web/cultivate/gateway/exchangeGoods.do"
};

/*************************************
 * 方法名称：goLogin
 * 功    能：跳转到登录页面
 * 参    数：无
 *************************************/
cc.goLogin = function() {
  location.href =
    cc.config.idsauthServerUrl +
    "/ids/login?service=" +
    encodeURIComponent(
      cc.config.idsauthUrl + "?targetUrl=" + encodeURIComponent(location.href)
    ) +
    "&loginTheme=wap_new";
  console.log(location.href);
};

/*************************************
 * 方法名称：goLoginARG
 * 功    能：跳转到登录页面
 * 参    数：限制跳转状态
 *************************************/
// cc.goLogin = function () {
//     location.href = cc.config.idsauthServerUrl + "/ids/login?service=" + encodeURIComponent(cc.config.idsauthUrl + "?targetUrl=" + encodeURIComponent(location.href)) + "&loginTheme=wap_new";
// };

/*************************************
 * 方法名称：checkLogin
 * 功    能：检测用户是否登录
 * 参    数：无
 *************************************/
cc.checkLogin = function(cb1, cb2, errorCb) {
  $.probeAuthStatus(
    function(userData) {
      cb1 && cb1();
    },
    function() {
      cb2 ? cb2() : cc.goLogin();
    },
    undefined,
    function() {
      if (errorCb) {
        errorCb();
      } else {
        // cc.toast("活动火爆，请稍后再试.");
      }
    }
  );
};

/*************************************
 * 方法名称：getCMSData
 * 功    能：获取CMS维护的数据
 * 参    数：无
 *************************************/
cc.getCMSData = function(actcode) {
  var cmsUrl = "";
  if ($.base.getEnvName() == "PRE") {
    cmsUrl = "//libprexg.cnsuning.com/api/jsonp/{actcode}.jsonp".replace(
      "{actcode}",
      actcode
    );
  } else {
    cmsUrl = cc.request_url.cmsUrl.replace("{actcode}", actcode);
  }
  return $.ajax({
    url: cmsUrl,
    dataType: "jsonp",
    jsonpCallback: "cmsCallback",
    contentType: "application/json;charset=utf-8"
  }).fail(function() {
    // cc.toast("活动火爆，请稍后再试..");
  });
};

/*************************************
 * 方法名称：requestPromise
 * 功    能：ajax请求
 * 参    数：返回promise
 *  默认入参加密，回参解密，业务无感知，如无必要加密，第二个参数传false,本地开发不加密
 *************************************/
cc.requestPromise = function(param = {}, isEncryption = false) {
  var miStr = "";
  var data;
  var resp_flag;
  if (process.env.NODE_ENV == "development") {
    isEncryption = false;
  }
  if (isEncryption) {
    for (const key in param.data) {
      miStr += key + "=" + encodeURIComponent(param.data[key]) + "&";
    }
    if (param.dataType == "jsonp") {
      resp_flag = 3;
    } else {
      resp_flag = 2;
    }
    data = {
      _x_req_block_: SuAES.encrypt(miStr.slice(0, miStr.length - 1)),
      _x_resp_flag_: resp_flag
    };
  } else {
    data = param.data;
  }
  return new Promise((resolve, reject) => {
    var callback = `callback${new Date().getMilliseconds()}`;
    console.log("callback:", callback);
    $.ajax({
      type: param.type || "GET",
      dataType: param.dataType || "json",
      beforeSend: function(xhr) {
        try {
          xhr.withCredentials = true;
        } catch (e) {
          var nativeOpen = xhr.open;
          xhr.open = function() {
            var result = nativeOpen.apply(xhr, arguments);
            xhr.withCredentials = true;
            return result;
          };
        }
      },
      url: param.url,
      timeout: 3000,
      data: data || {},
      jsonpCallback: param.callback || callback,
      success: function(res) {
        if (
          isEncryption &&
          res.hasOwnProperty("x_response_security") &&
          res.x_response_security == "1"
        ) {
          if (typeof SuAES.decrypt(res.security_data) === "string") {
            resolve(JSON.parse(SuAES.decrypt(res.security_data)));
          } else {
            resolve(SuAES.decrypt(res.security_data));
          }
        } else {
          resolve(res);
        }
      },
      complete: function(XHR, TextStatus) {
        if (TextStatus == "timeout") {
          // 超时执行的程序
          console.log("请求超时！");
          resolve("timeout");
        }
      }
    })
      .done(function(res) {
        console.log(res, 222);
        // 异常埋点
        // 接口名，入参，异常（直接用res）
        if (res && window.sendErrorMsg) {
          var result;
          if (
            isEncryption &&
            res.hasOwnProperty("x_response_security") &&
            res.x_response_security == "1"
          ) {
            if (typeof SuAES.decrypt(res.security_data) === "string") {
              result = JSON.parse(SuAES.decrypt(res.security_data));
            } else {
              result = SuAES.decrypt(res.security_data);
            }
          } else {
            result = res;
          }
          sendErrorMsg(res.api, param.data, result);
        }
      })
      .fail(function(e) {
        resolve("fail");
      });
  });
};

/*************************************
 * 方法名称：getJSON
 * 功    能：ajax请求
 * 参    数：fail_cc:失败时的回调函数
 *************************************/
cc.getJSON = function(url, data, fail_cc) {
  return $.ajax({
    type: "GET",
    dataType: "json",
    contentType: "application/json;charset=utf-8",
    beforeSend: function(xhr) {
      try {
        xhr.withCredentials = true;
      } catch (e) {
        var nativeOpen = xhr.open;
        xhr.open = function() {
          var result = nativeOpen.apply(xhr, arguments);
          xhr.withCredentials = true;
          return result;
        };
      }
    },
    url: url,
    data: data || {}
  })
    .done(function(res) {
      // 异常埋点
      if (res && window.sendErrorMsg) {
        sendErrorMsg(res.api, data, res);
      }
    })
    .fail(function() {
      if (fail_cc) {
        fail_cc();
      } else {
        // cc.toast("活动火爆，请稍后再试...");
      }
    });
};

/*************************************
 * 方法名称：getJSONP
 * 功    能：ajax请求
 * 参    数：fail_cc:失败时的回调函数
 *************************************/
cc.getJSONP = function(url, data, fail_cc) {
  return $.ajax({
    type: "GET",
    dataType: "jsonp",
    jsonp: "callback",
    url: url,
    data: data || {}
  })
    .done(function(res) {
      // 异常埋点
      // if (res && window.sendErrorMsg) {
      //     sendErrorMsg(res.api, data, res);
      // }
    })
    .fail(function() {
      if (fail_cc) {
        fail_cc();
      } else {
        // cc.toast("网络连接异常，请重试");
      }
    });
};

/*************************************
 * 方法名称：randomNum
 * 功    能：随机数
 * 参    数：无
 *************************************/
cc.randomNum = function(Min, Max) {
  var Range = Max - Min;
  var Rand = Math.random();
  // 四舍五入
  var num = Min + Math.round(Rand * Range);
  return num;
};

/*************************************
 * 方法名称：isSupportLocalStorage
 * 功    能：判断是否支持本地存储（兼容无痕模式）
 * 参    数：无
 *************************************/
cc.isSupportLocalStorage = function() {
  var testKey = "test";
  var storage = window.localStorage;
  try {
    storage.setItem(testKey, "testValue");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

/*************************************
 * 方法名称：toast
 * 功    能：toast提示
 * 参    数：无
 *************************************/
cc.toast = function(str, time, cb) {
  AlertBox({
    type: "mini",
    delay: time || 2000,
    msg: str,
    callback: cb
  });
};

/*************************************
 * 方法名称：showLoading
 * 功    能：展示loading
 * 参    数：无
 *************************************/
cc.showLoading = function() {
  $("body").append(
    '<div class="loading greensport-loading"><div data-loader="ball-auto"></div></div>'
  );
  // 防止出现一直loading的情况，5s后自动删除loading
  setTimeout(function() {
    cc.removeLoading();
  }, 8000);
};

/*************************************
 * 方法名称：removeLoading
 * 功    能：删除loading
 * 参    数：无
 *************************************/
cc.removeLoading = function() {
  $(".greensport-loading").remove();
};

/*************************************
 * 方法名称：openSNApp
 * 功    能：打开苏宁app
 * 参    数：无
 *************************************/
cc.openSNApp = function(url) {
  const _link =
    "http://c.m.suning.com/channelwap.htm?appid=1&packnversion=147&channelcode=40096&wap_source=%E6%98%93%E8%B4%AD%E7%AB%99%E5%86%85%E6%8B%BC%E8%B4%AD%E7%9F%AD%E4%BF%A1&wap_medium=40096&wap_content=&wap_term=&wap_campaign=&downflag=0&adTypeCode=1002&adId=" +
    url;
  location.href = _link;
};

/*************************************
 * 方法名称：openARScan
 * 功    能：打开苏宁appAR扫功能
 * 参    数：无
 *************************************/
cc.openARScan = function() {
  location.href = cc.request_url.appARSrc;
};

/*************************************
 * 方法名称：isMini
 * 功    能：判断是否在小程序中打开
 * 参    数：判断是否在小程序中打开
 *************************************/
cc.isMini = function() {
  if (!cc.os.wechat) return false;
  if (
    wx &&
    typeof wx === "object" &&
    wx.miniProgram &&
    window.__wxjs_environment === "miniprogram"
  ) {
    return true;
  }
  return false;
};

/*************************************
 * 方法名称：navigateTo
 * 功    能：跳转到小程序中的页面
 * 参    数：跳转到小程序中的页面
 *************************************/
cc.navigateTo = function(options) {
  wx.miniProgram.navigateTo(options);
};

/*************************************
 * 方法名称：getQueryString
 * 功    能：获取url参数
 * 参    数：name 参数名称
 *************************************/
cc.getQueryString = function(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

cc.isNumber = function(num) {
  return typeof num === "number" && num === +num;
};
cc.isArray =
  Array.isArray ||
  function(object) {
    return object instanceof Array;
  };
cc.isObject = function(obj) {
  var type = typeof obj;
  return type === "function" || (type === "object" && !!obj);
};
cc.isJSON = function(str) {
  try {
    if (typeof JSON.parse(str) == "object") {
      return true;
    }
  } catch (e) {
    console.log(e);
  }
  return false;
};
// url参数key=value&key=value转化为对象格式
cc.par2Json = function(string, overwrite) {
  var obj = {};
  var pairs = string.split("&");
  var name;
  var value;
  $.each(pairs, function(i, pair) {
    pair = pair.split("=");
    name = decodeURIComponent(pair[0]);
    value = decodeURIComponent(pair[1]);
    obj[name] = value;
  });
  return obj;
};
// 获取cookie
cc.getCookies = function(c) {
  var d;
  return (d = document.cookie.match(RegExp("(^| )" + c + "=([^;]*)(;|$)")))
    ? decodeURIComponent(d[2].replace(/\+/g, "%20"))
    : null;
};

var UTILS = {
  resourceData: {},
  layoutObject: function(obj, indexName = "main") {
    let arr = UTILS.resourceData;
    var indexname = indexName || "main";
    if (obj instanceof Array) {
      for (let i = 0; i < obj.length; i++) {
        UTILS.layoutObject(obj[i], indexname);
      }
    }
    // 如果是对象
    else if (obj instanceof Object) {
      for (var key in obj) {
        if (key === "modelFullCode" || key === "elementName") {
          indexname += "." + obj[key];
          arr[indexname] = obj;
        }
        if (key === "nodes" || key === "tag") {
          // nodes数组
          let nodes = obj[key];
          UTILS.layoutObject(nodes, indexname);
        }
        if (obj[key] instanceof Object) {
          UTILS.layoutObject(obj[key], indexname);
        }
      }
    }
  },
  getRes: function(name) {
    return UTILS.resourceData[name];
  }
};
cc.UTILS = UTILS;
var gameapi = {};
cc.gameapi = gameapi;
/* 客户端判断 */
cc.os = (function() {
  // pp视频发生过一开始ua取不到的情况
  if (navigator && navigator.userAgent) {
    var e = navigator.userAgent;
    return {
      yifubao: !!e.match(/SNYifubao;?/i),
      wechat: !!e.match(/MicroMessenger/i),
      isApp:
        e.match(/SNEBUY-APP;?/i) &&
        !e.match(/NEARBY-APP;?/i) &&
        !e.match(/SNUNION-APP;?/i) &&
        !e.match(/SNLPG-APP;?/i),
      isBadAndroid:
        /Android /.test(window.navigator.appVersion) &&
        !/Chrome\/\d/.test(window.navigator.appVersion) &&
        !window.e.match(/SNLITE-WAP/i),
      android: e.match(/android/i),
      iOS: e.match(/(iPhone|iPod|iPad);?/i),
      iPad: e.match(/(iPad).*OS\s([\d_]+)/),
      iPod: e.match(/(iPod)(.*OS\s([\d_]+))?/),
      chrome: e.match(/Chrome\/([\d.]+)/),
      isNearby: e.match(/NEARBY-APP;?/i), // 小店
      isSnUnion: e.match(/SNUNION-APP;?/i), // 推客
      isPPTV: e.indexOf(" PPTV (") > 0,
      isPPTVSports: e.toLocaleLowerCase().match(/pptvsports/i),
      isLPG: e.match(/SNLPG-APP;?/i)
    };
  } else {
    return {};
  }
})();
/*
统一处理code值，
-1，-2，-3重试一次失败后提示用户
3,4,5,6,7 失败后提示用户
2 引导用户登陆
*/
cc.delCode = function(code, callBack) {
  var text =
    {
      "3": "活动状态不正常",
      "4": "活动未开始",
      "5": "活动已结束",
      "6": "活动不存在",
      "17": "参数错误"
    }[String(code)] || "加油！换个姿势，再试一次～";
  if (!window.requesstCount) {
    window.requesstCount = 1;
  }
  if (code == "2") {
    cc.goLogin();
  } else if (code == "-1" || code == "-2" || code == "-3") {
    if (callBack && window.requesstCount < 2) {
      window.requesstCount++;
      callBack();
    } else {
      window.requesstCount = 1;
    }
  } else {
    cc.toast(text);
  }
};

/*************************************
 * 方法名称：bindName
 * 功    能：实名认证
 * 参    数：url 实名后跳转页面
 *************************************/
cc.bindName = function(link) {
  let url =
    cc.config.SWELL_mpayDomain +
    "epwm/identity/toIdentityVerification.htm?source=68&backUrl=" +
    encodeURIComponent(link);
  location.href = url;
};
// 时间戳转时分秒00:00:00格式
cc.formatDuring = function(millisecond) {
  if (millisecond < 0) return;
  var hours = parseInt(
    (millisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  var minutes = parseInt((millisecond % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = parseInt((millisecond % (1000 * 60)) / 1000);
  return (
    (hours < 10 ? "0" + hours : hours) +
    ":" +
    (minutes < 10 ? "0" + minutes : minutes) +
    ":" +
    (seconds < 10 ? "0" + seconds : seconds)
  );
};
// 时间戳转天时分格式
cc.formatDate = function(second) {
  var str = "";
  var days = parseInt(second / (60 * 60 * 24));
  var hours = parseInt((second % (60 * 60 * 24)) / (60 * 60));
  var minutes = parseInt((second % (60 * 60)) / 60);
  var seconds = parseInt(second % 60);
  if (days > 0) {
    str = str + days + "天";
  }
  if (hours > 0) {
    str = str + hours + "小时";
  }
  if (minutes > 0) {
    str = str + minutes + "分钟";
  }
  // if (seconds > 0) {
  //     str = str + seconds + '秒';
  // }
  return str;
};
// 获取数组中随机几项
cc.getRandomArray = function(arr, num) {
  var temp_array = new Array();
  for (let k = 0; k < arr.length; k++) {
    temp_array.push(arr[k]);
  }
  var return_array = new Array();
  for (var i = 0; i < num; i++) {
    if (temp_array.length > 0) {
      var arrIndex = Math.floor(Math.random() * temp_array.length);
      return_array[i] = temp_array[arrIndex];
      temp_array.splice(arrIndex, 1);
    } else {
      break;
    }
  }
  return return_array;
};
//  app环境打开新的webview路由页并跳转一个链接，其他环境直接跳转,link：链接，backCB：app内返回后的回调

cc.openNewWebview = function(link, backCB) {
  console.log("执行openNewWebview方法");
  if (cc.os.isApp) {
    console.log("易购客户端环境");
    try {
      // 不写在appready方法回调里，但页面要先加载sneapp.js
      var bridge = cc.os.iOS ? SNNativeClient : baseApi;
      if (backCB && typeof backCB === "function") {
        console.log("有传回调函数", backCB);
        window.snclient_viewDidAppear = function() {
          console.log("执行了snclient_viewDidAppear");
          backCB();
        };
      }
      if (bridge) {
        console.log("bridge存在：", bridge);
        if (cc.os.iOS && bridge.pushToNextPage) {
          bridge.pushToNextPage(link);
        } else if (cc.os.android && bridge.pageRouter) {
          var _url =
            "http://m.suning.com?adTypeCode=1002&adId=" +
            encodeURIComponent(link);
          baseApi.pageRouter(_url);
        }
      } else {
        $.AppReady(function(obj) {
          if (cc.os.iOS) {
            obj.pushToNextPage(url);
          } else {
            var _url =
              "http://m.suning.com?adTypeCode=1002&adId=" +
              encodeURIComponent(url);
            obj.baseApi.pageRouter(_url);
          }
        });
      }
    } catch (error) {
      location.href = link;
    }
  } else {
    location.href = link;
  }
};
// app环境关闭webview方法
cc.closeWebview = function(link) {
  try {
    if (cc.os.isApp) {
      var bridge = cc.os.iOS ? SNNativeClient : baseApi;
      if (bridge) {
        bridge.closeWapPage();
      } else {
        $.AppReady(function(obj) {
          obj.closeWapPage();
        });
      }
    } else {
      if (link) {
        window.location.href = link;
      } else {
        window.history.back();
      }
    }
  } catch (error) {
    if (link) {
      window.location.href = link;
    } else {
      window.history.back();
    }
  }
};
export default cc;
